import { Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import type { ChatRailTokens } from "../../tokens";
import { JsonResultRenderer } from "./JsonResultRenderer";
import { ScalarRow, pickStringField } from "./registry";

export function OrganizationRenderer({
  kind,
  payload,
  T,
}: {
  kind: "invocation" | "result";
  payload: unknown;
  T: ChatRailTokens;
}) {
  if (kind === "invocation") return <JsonResultRenderer payload={payload} T={T} />;

  const id = pickStringField(payload, "id", "organization_id");
  const name = pickStringField(payload, "name", "display_name", "company_name");
  const domain = pickStringField(payload, "domain", "website");
  const industry = pickStringField(payload, "industry");

  if (!name && !id) return <JsonResultRenderer payload={payload} T={T} />;

  return (
    <Stack spacing={0.5}>
      {name && id ? (
        <ScalarRow
          label="org"
          value={
            <RouterLink
              to={`/organizations/${id}`}
              style={{ color: T.accent, textDecoration: "none" }}
            >
              {name}
            </RouterLink>
          }
          T={T}
        />
      ) : name ? (
        <ScalarRow label="org" value={name} T={T} />
      ) : null}
      {domain && <ScalarRow label="domain" value={domain} T={T} />}
      {industry && <ScalarRow label="industry" value={industry} T={T} />}
    </Stack>
  );
}
